// export const API_URL = 'https://analysthub.marketised.com/';
// export const API_URL = 'http://128.199.66.105/';
export const API_URL = process.env.MIX_APP_URL;
export default API_URL;

// process.env.MIX_APP_CHARGEBEE_URL
